import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SidebarMenu extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={`sidebar-menu sidebar-menu--${this.props.style}`}>
        { this.props.top &&
          <div className="sidebar-menu__top">{ this.props.top }</div>
        }

        <div className="sidebar-menu__items">
          { this.props.items && this.props.items.map(({ id=undefined, label, color, icon=undefined }, index) => (
            <div
              key={index}
              className="sidebar-menu__item"
              onClick={this.onItemClick.bind(this, id)}
            >
              { this.props.numbered &&
                <span className={`sidebar-menu__item__index${color ? ` sidebar-menu__item__index--${color}` : ''}`}>
                  {index + 1}
                </span>
              }
              { icon && <i className={`icon icon--${icon}`} /> }
              <span className="sidebar-menu__item__title">{ label }</span>
            </div>
          )) }
        </div>

        { this.props.bottom &&
          <div className="sidebar-menu__bottom">{ this.props.bottom }</div>
        }
      </div>
    );
  }

  onItemClick(id) {
    if (id) { this.props.onItemClick(id); }
  }
}

SidebarMenu.defaultProps = {
  style: 'pampas',
  numbered: false,
  onItemClick: () => {}
};

SidebarMenu.propTypes = {
  style: PropTypes.string,
  numbered: PropTypes.bool,
  items: PropTypes.array,
  top: PropTypes.any,
  bottom: PropTypes.any,
  onItemClick: PropTypes.func
};

export default SidebarMenu;
